export default "__VITE_ASSET__B0vq3P2O__"